
/**
 * @fileOverview HotSpotView module definition
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    //ToDo Refactor names into global vars for this class

    define('views/HotSpotView',['require','jquery','lib/Util','GlobalEventDispatcher','GlobalResizeListener'],function(require) {
        
        var $ = require('jquery');
        var Util = require('lib/Util');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');
        var GlobalResizeListener = require('GlobalResizeListener');


        /**
         * A sample view script. Reveals a message using a card-flip animation.
         *
         * @class HotSpotView
         * @param {jQuery} $element A reference to the containing DOM element
         * @constructor
         */
        var HotSpotView = function($element) {
            /**
             * A reference to the containing DOM element
             *
             * @default null
             * @property $element
             * @type {jQuery}
             */
            this.$element = $element;

            /**
             * The global instance of an event dispatcher, used to subscribe to or publish events of global interest
             *
             * @default GlobalEventDispatcher.getEventDispatcher()
             * @property GlobalEventDispatcher
             * @type {jQuery}
             */
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();

            /**
             * The global instance of an event dispatcher, used to subscribe to or publish events of global interest
             *
             * @default GlobalResizeListener.getResizeListener()
             * @property GlobalResizeListener
             * @type {jQuery}
             */
            this.globalResizeListener = GlobalResizeListener.getResizeListener();

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @property isEnabled
             * @type bool
             */
            this.isEnabled = false;

            /**
             * Tracks whether component is in small context.
             *
             * @default false
             * @property isEnabled
             * @type bool
             */
            this.isSmallContext = false;

            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         * Exits early if it is already initialized
         *
         * @method init
         * @returns {HotSpotView}
         */
        HotSpotView.prototype.init = function() {

            this.HOTSPOTS_CONTAINER = 'js-hotspots-container';
            this.HOTSPOT_ITEM = 'js-hotspots-item';
            this.HOTSPOT_IN_HERO_HOTSPOT = 'js-hotspots-inHero';
            this.HOTSPOT_IN_HERO_TRIGGER = 'js-hotspots-inHero-trigger';
            this.HOTSPOT_IN_HERO_TARGET = 'js-hotspots-inHero-target';
            this.HOTSPOT_IN_HERO_TARGET_CLOSE = 'js-hotspots-inHero-target-close';
            this.HOTSPOT_IN_HERO_TARGET_PANEL = 'js-hotspots-inHero-target-panel';

            this.setupHandlers()
                .createChildren()
                .resizeCheck()
                .layout()
                .enable();

            return this;
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * This creates event handlers and binds the scope
         * of the JS.
         *
         * @method setupHandlers
         * @returns {HotSpotView}
         */
        HotSpotView.prototype.setupHandlers = function() {
            // Bind event handlers scope here
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.WINDOW_RESIZE, this.layout.bind(this));
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.CONTEXT_CHANGE, this.resizeCheck.bind(this));
            this.onClickHandler = this.onClick.bind(this);
            this.onClickCloseHandler = this.onClickClose.bind(this);

            return this;
        };

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @method createChildren
         * @returns {HotSpotView}
         */
        HotSpotView.prototype.createChildren = function() {
            this.hotSpotContainer = this.$element.find('.' + this.HOTSPOTS_CONTAINER);
            this.hotSpot = this.$element.find('.' + this.HOTSPOT_ITEM);
            this.hotSpotHero = this.hotSpot.find('.' + this.HOTSPOT_IN_HERO_HOTSPOT);
            this.hotSpotHeroTrigger = this.hotSpotHero.find('.' + this.HOTSPOT_IN_HERO_TRIGGER);
            this.hotSpotHeroTarget = this.hotSpotHero.find('.' + this.HOTSPOT_IN_HERO_TARGET);
            this.hotSpotHeroClose = this.hotSpotHeroTarget.find('.' + this.HOTSPOT_IN_HERO_TARGET_CLOSE);

            return this;
        };

        /**
         * Remove any child objects or references to DOM elements
         *
         * @method removeChildren
         * @returns {HotSpotView}
         */
        HotSpotView.prototype.removeChildren = function() {

            return this;
        };

        /**
         * In layout the first test is to see if the DOM is in small context.
         * If it is all the positioning is skipped. It would remove the
         * 'isInactive' class from hotSpotHeroTarget and then removes 'isActive'
         * class to the Target and the Trigger, then it will add the 'isInactive'
         * class back onto hotSpotHeroTarget. The reason for removing the 'isInactive'
         * is to allow a measurement of the containers. Then at the end it adds it back.
         *
         * If it is small context some layout happens. It is meant to ensure that
         * the box will always appear in the hero and never overflows.
         *
         *
         * @method layout
         * @returns {HotSpotView}
         */
        HotSpotView.prototype.layout = function() {
            var containerHeight = this.hotSpotContainer.height();
            var containerWidth = this.hotSpotContainer.width();
            var containerOffset = this.hotSpotContainer.offset().top;

            this.hotSpotHeroTarget.removeClass('MMM--isInactive');


            if(!this.isSmallContext) {
                this.hotSpotHero.each(function () {
                    var $this = $(this);

                    var hotSpotTop = parseInt($this.css('top'),10);
                    var hotSpotLeft = parseInt($this.css('left'),10) - 120;
                    var hotSpotRight = parseInt($this.css('left'),10) + 402 - 120;
                    var hotSpotOffset = parseInt($this.offset().top,10);
                    var targetHeight = $this.find('.js-hotspots-inHero-target').height();
                    var hotSpotPanelHeight = parseInt($this.find('.js-hotspots-inHero-target').height(),10);
                    var diff;

                    if((hotSpotTop + hotSpotPanelHeight) > containerHeight && (hotSpotOffset - targetHeight) > containerOffset) {
                        $this.find('.MMM--hotspot-listItem-trigger-arrow_down').remove();
                        $this.find('.MMM--hotspot-listItem-trigger-arrow_up').remove();
                        $this.find('.js-hotspots-inHero-target').append('<div class="MMM--hotspot-listItem-trigger-arrow_down"></div>');

                        targetHeight = $this.find('.js-hotspots-inHero-target').height();

                        $this.find('.js-hotspots-inHero-target').css({
                            'top' : -targetHeight + 'px'
                        });
                    } else {
                        $this.find('.js-hotspots-inHero-target').css({
                            'top' : 'auto'
                        });
                        $this.find('.MMM--hotspot-listItem-trigger-arrow_up').remove();
                        $this.find('.MMM--hotspot-listItem-trigger-arrow_down').remove();
                        $this.find('.js-hotspots-inHero-target').prepend('<div class="MMM--hotspot-listItem-trigger-arrow_up"></div>');
                    }

                    if(hotSpotRight > containerWidth) {
                        diff =  hotSpotRight - containerWidth;
                        $this.find('.js-hotspots-inHero-target-panel').css({
                            'right' : 120+diff
                        });
                    }

                    if(hotSpotLeft < 0) {
                        diff = hotSpotLeft;
                        $this.find('.js-hotspots-inHero-target-panel').css({
                            'right' : 120+diff
                        });
                    }
                });
            }

            this.hotSpotHeroTarget.removeClass('MMM--isActive');
            this.hotSpotHeroTrigger.removeClass('MMM--isActive');
            this.hotSpotHeroTarget.addClass('MMM--isInactive');

            return this;
        };

        /**
         * Enables the component
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {HotSpotView}
         */
        HotSpotView.prototype.enable = function() {
            if (this.isEnabled) {
                return this;
            }
            this.isEnabled = true;
            this.hotSpotHero.on('click', this.hotSpotHeroTrigger, this.onClickHandler);
            this.hotSpotHeroClose.on('click', this.onClickCloseHandler);

            return this;
        };

        /**
         * Disables the component
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @method disable
         * @returns {HotSpotView}
         */
        HotSpotView.prototype.disable = function() {
            if (!this.isEnabled) {
                return this;
            }
            this.isEnabled = false;
            this.hotSpotHero.off('click', this.hotSpotHeroTrigger, this.onClickHandler);
            this.hotSpotHeroClose.off('click', this.onClickCloseHandler);


            return this;
        };

        /**
         * Destroys the component
         * Tears down any events, handlers, elements
         * Should be called when the object should be left unused
         *
         * @method destroy
         * @returns {HotSpotView}
         */
        HotSpotView.prototype.destroy = function() {
            this.disable()
                .removeChildren();
            return this;
        };

        //////////////////////////////////////////////////////////////////////////////////
        // EVENT HANDLERS
        //
        // Place events here, use event handlers to access it
        //////////////////////////////////////////////////////////////////////////////////

        /**
         * onClick handler
         * On clicking the hot spot it closes any active
         * panel and opens the currently target panel.
         *
         * @method onClick
         * @param {Event} e JavaScript event object
         */
        HotSpotView.prototype.onClick = function(e) {
            var self = this;
            var $currentTarget = $(e.currentTarget);
            var $targetPanel = $currentTarget.find('.' + this.HOTSPOT_IN_HERO_TARGET);
            var $target = $(e.target);

            console.log('target '+ $target.attr('class'));
            if($target.hasClass(this.HOTSPOT_IN_HERO_TRIGGER)) {
                if ($targetPanel.hasClass('MMM--isInactive')) {
                    // This closes any other open panel
                    this.$element.find('.' + this.HOTSPOT_IN_HERO_TARGET + '.MMM--isActive').each(function() {
                        var $this = $(this);
                        self.closeHotSpot($this);
                    });


                    // Then open the target panel
                    this.openHotSpot($targetPanel);

                } else if($targetPanel.hasClass('MMM--isActive')) {
                    this.closeHotSpot($targetPanel);
                }
            }
            else if (($target.hasClass('MMM--hotspot-listItem-cta'))) {
                return true;
            }
            else {
                return false;
            }




        };

        /**
         * onClickClose handler
         * On clicking the close button the hot spot
         * panel closes
         *
         * @method onClickClose
         * @param {Event} e JavaScript event object
         */
        HotSpotView.prototype.onClickClose = function(e) {
            e.stopPropagation();
            if (e.preventDefault) {
                e.preventDefault();
            }
            else {
                //needed for IE Support
                e.returnValue = false;
            }

            var $currentTarget = $(e.currentTarget);
            var $targetPanel = $currentTarget.parents('.' + this.HOTSPOT_IN_HERO_TARGET);


            this.closeHotSpot($targetPanel);

        };



        //////////////////////////////////////////////////////////////////////////////////
        // Helper Functions
        //
        // Place logic here so things are more abstracted.
        //////////////////////////////////////////////////////////////////////////////////

        /**
         * Displays the hot spot while closing other hot spots that
         * may be open.
         *
         * @method openHotSpot
         * @param {Event} $targetPanel JQuery object passed into function
         * by click function - this should be what you want to toggle between
         * active and inactive.
         */
        HotSpotView.prototype.openHotSpot = function($targetPanel) {
            $targetPanel.removeClass('MMM--isInactive');
            $targetPanel.addClass('MMM--isActive');
            $targetPanel.parents('.' + this.HOTSPOT_IN_HERO_HOTSPOT).find('.' + this.HOTSPOT_IN_HERO_TRIGGER).addClass('MMM--isActive');
        };

        /**
         * Closes open hot spots.
         *
         * @method closeHotSpot
         * @param {Event} $targetPanel JQuery object passed into function
         * by click function - this should be what you want to toggle between
         * active and inactive.
         */
        HotSpotView.prototype.closeHotSpot = function($targetPanel) {
            $targetPanel.removeClass('MMM--isActive');
            $targetPanel.addClass('MMM--isInactive');
            $targetPanel.parents('.' + this.HOTSPOT_IN_HERO_HOTSPOT).find('.' + this.HOTSPOT_IN_HERO_TRIGGER).removeClass('MMM--isActive');
        };

        /**
         * This checks the current context from the event dispatcher. If it is
         * in small context, isSmallContext sets to true, any other context sets to
         * false.
         *
         * @method resizeCheck
         * @returns {ExpandContentView}
         * @private
         */
        HotSpotView.prototype.resizeCheck = function() {
            var context = this.globalResizeListener.getCurrentContext();

            if(context === 'smallContext') {
                this.isSmallContext = true;
            } else {
                this.isSmallContext = false;
            }

            return this;

        };

        return HotSpotView;
    });

}(MMMRequire));

